/* RAVNAR COLLECTION PRODUCT IMAGE ROTATION — 1 SECOND */
(function(){
  'use strict';
  var INTERVAL=1000;
  var initialized=new WeakSet();

  function style(){
    if(document.getElementById('ravnar-collection-rotation-style')) return;
    var s=document.createElement('style');
    s.id='ravnar-collection-rotation-style';
    s.textContent='.rvx-collection-rotator{position:relative!important;display:block!important;width:100%!important;height:100%!important;overflow:hidden!important}.rvx-collection-rotator img{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;opacity:0!important;transition:opacity .35s ease!important}.rvx-collection-rotator img.rvx-rotation-active{opacity:1!important}.rvx-collection-rotator img:first-child{position:relative!important}.rvx-collection-rotator img.rvx-rotation-active~img{opacity:0!important}@media(prefers-reduced-motion:reduce){.rvx-collection-rotator img{transition:none!important}}';
    document.head.appendChild(s);
  }

  function productUrl(card){
    var link=card.querySelector('a[href*="/products/"]');
    return link ? link.href.split('#')[0].split('?')[0] : null;
  }

  function makeImage(src,alt){
    var img=document.createElement('img');
    img.src=src;
    img.alt=alt||'';
    img.loading='lazy';
    img.decoding='async';
    return img;
  }

  async function initCard(card){
    if(initialized.has(card)) return;
    var media=card.querySelector('.card__media .media--hover-effect');
    if(!media) return;
    var url=productUrl(card);
    if(!url) return;
    initialized.add(card);
    try{
      var res=await fetch(url+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!res.ok) return;
      var product=await res.json();
      var urls=[];
      (product.images||[]).forEach(function(src){if(src&&!urls.includes(src)) urls.push(src);});
      if(urls.length<2) return;
      var original=media.querySelector('img');
      var alt=original ? original.alt : product.title;
      media.innerHTML='';
      var rotator=document.createElement('div');
      rotator.className='rvx-collection-rotator';
      urls.forEach(function(src,i){
        var img=makeImage(src,alt);
        if(i===0) img.classList.add('rvx-rotation-active');
        rotator.appendChild(img);
      });
      media.appendChild(rotator);
      var imgs=Array.prototype.slice.call(rotator.querySelectorAll('img'));
      var index=0;
      setInterval(function(){
        if(document.hidden) return;
        imgs[index].classList.remove('rvx-rotation-active');
        index=(index+1)%imgs.length;
        imgs[index].classList.add('rvx-rotation-active');
      },INTERVAL);
    }catch(e){
      initialized.delete(card);
    }
  }

  function scan(){
    style();
    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(function(card){initCard(card);});
  }
  function boot(){
    scan();
    new MutationObserver(function(){scan();}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',scan);
})();
